export default {"src":"/_next/static/media/ETN.8331bb71.svg","height":18,"width":18};